// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fh-a";
export var fulfillmentFormRail = "_fh-9";
export var headerTitleRow = "_fh-c";
export var orderDetailsWrapper = "_fh-7";
export var orderLinkTrigger = "_fh-2";
export var paymentInformationGrid = "_fh-h";
export var paymentSummaryColumn = "_fh-i";
export var shipmentContainer = "_fh-b";
export var shipmentDetailsMainPane = "_fh-8";
export var shipmentNavigationCard = "_fh-5";
export var shipmentNavigationRail = "_fh-3";
export var shipmentNavigationRailHeader = "_fh-4";
export var shipmentSummaryFact = "_fh-e";
export var shipmentSummaryGrid = "_fh-d";
export var shipmentSummaryMetadataRow = "_fh-f";
export var shipmentSummaryTags = "_fh-g";
export var shipmentWorkspace = "_fh-0";
export var shipmentWorkspaceContent = "_fh-6";
export var shipmentWorkspaceHeader = "_fh-1";